type ExtensionSettings = overwolf.settings.GeneralExtensionSettings;

// -----------------------------------------------------------------------------
export class OWSettings {
  // ---------------------------------------------------------------------------
  public static getLanguage(): Promise<string> {
    return new Promise((resolve) => {
      overwolf.settings.language.get((result) => {
        return resolve(result.language);
      });
    });
  }

  // ---------------------------------------------------------------------------
  public static getExtensionSettings():
  Promise<ExtensionSettings> {
    return new Promise((resolve, reject) => {
      overwolf.settings.getExtensionSettings(result => {
        return resolve(result.settings);
      });
    });
  }

  // ---------------------------------------------------------------------------
  public static setExtensionSettings(settings: ExtensionSettings):
  Promise<boolean> {
    return new Promise((resolve, reject) => {
      overwolf.settings.setExtensionSettings(
        settings,
        result => {
          return resolve(result.success);
        }
      );
    });
  }
}
